import initBScroll from "@/utils/bScroll";
import { dateFormat } from "@/utils";
import { snkd } from "@/api/api";
import $axios from "@/utils/request";

export default {
  data() {
    return {
      /* 第三方设备 */
      //* 所有marker点数据信息
      thirdMarkerList: [],
      //* 当前点击的marker的dom等信息
      thirdCurrentMarkerTarget: null,
      //* 当前点击的marker的数据信息
      thirdCurrentMarkerData: {
        id: null,
        displayName: "",
      },
      //* 当前点击的详情页环境监测sensorList数据
      thirdSensorList: null,
      //* 有虫情数据, 还是有孢子数据,默认没有虫情数据
      hasBug: false,
      hasSpore: false,
      hasInsecticidal: false,
      //* 没有图片时,noImg地址
      noImg: require("@/assets/images/bs/farm-detail/no_img1.jpg"),
      //* 虫情走势echarts数据
      xData: [],
      //* 接口
      iotAccessThirdDeviceList: snkd.produce.iotAccessThird.deviceList, //* 获取第三方物联网设备列表
      iotAccessThirdDeviceGetDetail:
        snkd.produce.iotAccessThird.deviceGetDetail, //* 获取第三方物联网设备详情
      iotAccessThirdDeviceHistory: snkd.produce.iotAccessThird.deviceHistory, //* 获取第三方物联网设备历史数据
      iotAccessThirdDeviceBugList: snkd.produce.iotAccessThird.deviceBugList, //* 第三方虫情数据列表
      iotAccessThirdDeviceBugPicDistinguish:
        snkd.produce.iotAccessThird.deviceBugPicDistinguish, //* 第三方虫情图片分析
      iotAccessThirdDeviceBugAnalyHistory:
        snkd.produce.iotAccessThird.deviceBugAnalyHistory, //* 第三方虫情分析历史数据
      //* 参数
      dateTime: {},
    };
  },
  mounted() {},
  methods: {
    // ToDo: 初始化module
    async initThirdModule() {
      let res = await this.getThirdMarkerListService();
      if (!res || !res.list || !res.list.length) return;
      const { list } = res;
      list.map(
        ({ deviceId, lat, lng, displayName, gateCategoryIcon, vendorCode }) => {
          this.thirdMarkerList.push({
            id: deviceId,
            lat: lat,
            lng: lng,
            displayName,
            icon: gateCategoryIcon,
            vendorCode,
            deviceId,
            iframeUrl: "",
            onlineFlag: null,
          });
        }
      );
      if (this.showShanghaiMap) {
        await this.OffsetAllPointerHander(this.thirdMarkerList);
      }
      //* 获取最近14天时间范围
      this.dateTime = this.getMapLastTime();
      await this.getDeviceDetailServiceControlller();

      // let hasRobotDevices = false;
      for (let i = 0; i < this.thirdMarkerList.length; i++) {
        let device = this.thirdMarkerList[i];
        // if (device.vendorCode === 3) {
        // 	const res = await this.getLatestPositionService(device.deviceId);
        // 	device.lat = res.lat;
        // 	device.lng = res.lng;
        // 	hasRobotDevices = true;
        // }
        device.marker = await this._initThirdMarker(device);
      }
      // 如果有机器人设备 就开启定时器 实时更新更新渲染
      // if(hasRobotDevices){
      // 	this.setIntervalTimer = setInterval(() => {
      // 		this.updatePoint();
      // 	}, 10000);
      // }
    },
    //* 初始化marker点
    _initThirdMarker(item) {
      const myIcon = L.divIcon({
        className: "my-div-icon",
        iconAnchor: [32 / 2, 47], //偏移位置
        html: this._returnThirdHtmlTemplate({
          icon: item.icon,
          vendorCode: item.vendorCode,
        }),
        iconSize: [32, 47],
      });
      item.marker = L.marker([item.lat, item.lng], {
        icon: myIcon,
        title: item.displayName,
        draggable: false,
      }).addTo(this.map);
      item.marker._icon.setAttribute("flag", "third_" + item.id);
      item.marker.on("click", ({ target }) => {
        this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
        this._thirdClickMarkerHandle(target, item);
      });
    },
    //* 点击marker点的回调
    async _thirdClickMarkerHandle(target, itemMarkerData) {
      const { id, lat, lng } = itemMarkerData;
      if (this.thirdCurrentMarkerData) {
        const { id: prevId } = this.thirdCurrentMarkerData;
        //* 如果已经选中，则不需要以下操作
        if (id === prevId) return;
      }
      layer.closeAll();
      await this.setThirdAsyncFun(300); //closeAll似乎是异步的，不等待一下会有问题

      //* 添加marker点active状态
      this.thirdCurrentMarkerTarget &&
        this._removeThirdMarkerActiveClass(this.thirdCurrentMarkerTarget._icon);
      this._setThirdMarkerActiveClass(target._icon);
      this._thirdMapMovePos({ lat, lng });
      //* 赋值新的数据
      this.thirdCurrentMarkerTarget = target;
      this.thirdCurrentMarkerData = itemMarkerData;
      this._initThirdGatewayLayer(itemMarkerData);
    },
    updatePoint() {
      this.thirdMarkerList.map(async (item, index) => {
        if (item.vendorCode === 3) {
          const res = await this.getLatestPositionService(item.id);
          this.thirdMarkerList[index].lat = res.lat;
          this.thirdMarkerList[index].lng = res.lng;
          item.marker
            .setLatLng([res.lat, res.lng], { noMoveStart: true })
            .update();
        }
      });
    },
    async getDeviceDetailServiceControlller() {
      await Promise.allSettled(
        this.thirdMarkerList.map(async (item, index) => {
          if (item.vendorCode === 3) {
            const res = await this.getIotAccessThirdDeviceDetailService(
              item.id
            );
            this.thirdMarkerList[index].iframeUrl = res.iframeUrl;
            this.thirdMarkerList[index].onlineFlag = res.onlineFlag;
          }
        })
      );
    },
    async getLatestPositionService(deviceId) {
      return new Promise((resolve) => {
        $axios
          .post(snkd.produce.iotAccessThird.getLatestPosition, {
            farmId: this.farmId,
            deviceId,
          })
          .then((res) => {
            if (res.respCode == 0) {
              resolve(res.obj);
            }
          });
      });
    },
    destroyModule() {
      this.setIntervalTimer && clearInterval(this.setIntervalTimer);
      this.setIntervalTimer = null;
    },

    // ToDo: ------ 服务 ------
    //* 第三方虫情分析历史数据
    getIotAccessThirdDeviceBugAnalyHistoryService(startTime, endTime) {
      const {
        farmId,
        thirdCurrentMarkerData: { id },
      } = this;
      return new Promise((resolve) => {
        $axios
          .post(this.iotAccessThirdDeviceBugAnalyHistory, {
            deviceId: id,
            endTime,
            farmId: farmId,
            startTime,
          })
          .then((res) => {
            console.log("第三方虫情分析历史数据", res);
            if (res.respCode == 0) {
              const { list } = res.obj;
              this.bugEchartsList = list;
              if (list.length > 0) {
                const xData = [];
                const yData = [];
                list.map((item) => {
                  xData.push(dateFormat(item.timestamp, "yyyy.MM.dd"));
                  yData.push(item.bugNum);
                });
                resolve({ xData, yData });
                return;
              }
              resolve(true);
            }
          });
      });
    },
    //* 获取第三方虫情数据列表
    getIotAccessThirdDeviceBugListService() {
      const {
        farmId,
        thirdCurrentMarkerData: { id },
        dateTime: { startTime, endTime },
      } = this;
      return new Promise((resolve) => {
        $axios
          .post(this.iotAccessThirdDeviceBugList, {
            deviceId: id,
            endTime,
            farmId: farmId,
            pageNo: 1,
            pageSize: 30,
            startTime,
          })
          .then((res) => {
            if (res.respCode == 0) {
              resolve(res.obj);
            } else {
              resolve({
                list: [],
                totalCount: 0,
              });
            }
          });
      });
    },
    // 获取第三方物联网设备历史数据
    getIotAccessThirdDeviceHistoryService({ itemHistoryId, identifier }) {
      const time = dateFormat(Date.now(), "yyyy-MM-dd");
      return new Promise((resolve) => {
        $axios
          .post(this.iotAccessThirdDeviceHistory, {
            deviceId: itemHistoryId,
            endTime: time,
            farmId: this.farmId,
            identifier: identifier,
            pageNo: 1,
            pageSize: 1500,
            startTime: time,
          })
          .then((res) => {
            if (res.respCode == 0) {
              resolve(res.obj);
            } else {
              resolve({
                sensor: { unit: "" },
                histories: [],
              });
            }
          });
      });
    },
    // 获取第三方物联网设备详情
    getIotAccessThirdDeviceDetailService(
      deviceId = this.thirdCurrentMarkerData.id
    ) {
      return new Promise((resolve) => {
        $axios
          .post(this.iotAccessThirdDeviceGetDetail, {
            farmId: this.farmId,
            deviceId,
          })
          .then((res) => {
            if (res.respCode == 0) {
              resolve(res.obj);
            } else {
              resolve({
                controllerList: [],
                sensorList: [],
                hasBug: false,
                hasSpore: false,
              });
            }
          });
      });
    },
    // 获取第三方物联网设备列表
    getThirdMarkerListService() {
      return new Promise((resolve) => {
        $axios
          .post(this.iotAccessThirdDeviceList, {
            farmId: this.farmId,
            pageNo: 1,
            pageSize: 200,
          })
          .then((res) => {
            if (res.respCode == 0) {
              resolve(res.obj);
            } else {
              resolve({ list: [] });
            }
          });
      });
    },

    // ToDo: ------ 弹窗模板 ------
    //* 初始化网关弹窗
    _initThirdGatewayLayer(itemMarkerData) {
      let _this = this;
      this.sensorListScroll = null;
      this.controllerListScroll = null;
      this.thirdDeviceBugListScroll = null;
      // 打开弹框
      window.layer.open({
        type: 1,
        skin: "anilayer sensormonitorlayer",
        resize: false,
        content: `
				<div id="newVersion" class="equiplayer sensormonitor">
					<div class="QggcQDeviceList-loader"></div>
					<span class="closebtn" onClick="window.layer.closeAll()"></span>
					<div class="sensormonitor-main"></div>
				</div>`,
        title: false,
        area: ["659px", "399px"],
        shade: 0,
        anim: -1,
        success: async () => {
          //TODO: loading
          if ($(".sensormonitor .QggcQDeviceList-loader").get(0))
            this._initThirdDeviceBugHistoryLoader({
              mountPoint: $(".sensormonitor .QggcQDeviceList-loader"),
            });
          // ToDo: 渲染第三方设备详情页数据
          const {
            controllerList,
            sensorList,
            hasBug,
            hasSpore,
            hasInsecticidal,
          } = await this.getIotAccessThirdDeviceDetailService();
          //* 当前点击的详情页环境监测sensorList数据
          this.thirdSensorList = sensorList;
          this.hasBug = hasBug;
          this.hasSpore = hasSpore;
          this.hasInsecticidal = hasInsecticidal;
          let thirdDeviceBugList = [];
          if (hasBug || hasSpore) {
            const { list } = await this.getIotAccessThirdDeviceBugListService();
            thirdDeviceBugList = list;
          }
          let bugxData, bugyData;
          if (this.hasBug) {
            const { startTime, endTime } = this.dateTime;
            const res =
              await this.getIotAccessThirdDeviceBugAnalyHistoryService(
                startTime,
                endTime
              );
            if (!res) return;
            const { xData, yData } = res;
            bugxData = xData;
            bugyData = yData;
          }
          let insecticidaxData, insecticidayData;
          if (this.hasInsecticidal) {
            const { startTime, endTime } = this.dateTime;
            const res = await this.getInsectStatistics(startTime, endTime);
            if (!res) return;
            const { xData, yData } = res;
            insecticidaxData = xData;
            insecticidayData = yData;
          }

          // 内容模板template
          const listTpl = this._getContentTemplateController({
            thirdSensorList: sensorList,
            controllerList,
            thirdDeviceBugList,
            bugEchartsList: this.bugEchartsList,
            insectStatisticsEchartsList: this.insectStatisticsEchartsList,
            hasBug,
            hasSpore,
            hasInsecticidal,
            itemMarkerData,
          });
          //* 数据渲染到html
          $(".sensormonitorlayer .sensormonitor .sensormonitor-main").html(
            listTpl
          );

          $(".daLu-wrap .daLuBtn").on("click", () => {
            itemMarkerData.iframeUrl && window.open(itemMarkerData.iframeUrl);
          });

          if (this.hasBug && bugxData) {
            await this.$nextTick(() => {
              this.QggcQDeviceEchartfn(
                bugxData,
                bugyData,
                $(
                  ".sensormonitor .QggcQDeviceList .QggcQDeviceList-wrap .QggcQDevice-echart"
                ).get(0)
              );
            });
          }
          if (this.hasInsecticidal && insecticidaxData) {
            this.$nextTick(() => {
              this.shacDeviceEchartsfn(
                insecticidaxData,
                insecticidayData,
                $(".sensormonitor .shaC-wrap>.shaC-echart").get(0)
              );
            });
          }

          const listDoms = ".sensormonitor .monitorlist ul li";
          //* 渲染传感设备的数字数据
          $(listDoms).each(function () {
            _this._thirdZaNumber($(this).find(".sensoritem .sensornum"));
          });
          //* 初始化滚动条
          if ($(".sensormonitor .sensorlist").get(0) && sensorList.length > 3) {
            this.sensorListScroll = initBScroll(
              $(".sensormonitor .sensorlist").get(0)
            );
            /*以下三行是为了解决 低版本浏览器 滚动时莫名其妙的样式问题*/
            $(".sensormonitor .monitorlist>ul>li").css("overflow", "hidden");
            this.sensorListScroll.scrollTo(0, -1);
            this.sensorListScroll.scrollTo(0, 0);
          }
          if (
            $(".sensormonitor .controlerlist").get(0) &&
            controllerList.length > 3
          ) {
            this.controllerListScroll = initBScroll(
              $(".sensormonitor .controlerlist").get(0)
            );
            $(".sensormonitor .monitorlist>ul>li").css("overflow", "hidden");
            this.controllerListScroll.scrollTo(0, -1);
            this.controllerListScroll.scrollTo(0, 0);
          }
          if (this.hasBug) {
            if ($(".sensormonitor .QggcQDeviceList").get(0)) {
              this.thirdDeviceBugListScroll = await initBScroll(
                document.querySelector(".sensormonitor .QggcQDeviceList")
              );
              this.thirdDeviceBugListScroll.scrollToElement(
                $(".sensormonitor .QggcQDeviceList").get(0),
                0,
                0,
                0
              );
            }
          } else {
            if (thirdDeviceBugList.length > 2) {
              this.thirdDeviceBugListScroll = initBScroll(
                $(".sensormonitor .QggcQDeviceList").get(0)
              );
              this.thirdDeviceBugListScroll.scrollToElement(
                $(".sensormonitor .QggcQDeviceList").get(0),
                0,
                0,
                0
              );
            }
          }
          //* 结束loading
          $(".sensormonitor .QggcQDeviceList-loader").remove();

          let tempScrollInfo = null;
          //* 给历史数据添加点击事件
          if ($(listDoms).length > 1) {
            $(".sensormonitor .sensorlist ul").on(
              "click",
              ".senhistory_btn",
              function () {
                let liitem = $(this).closest("li");
                if (liitem.hasClass("active")) {
                  liitem
                    .find(".sensor_history")
                    .html('<div class="historycon"></div>');
                  $(this)
                    .closest("li")
                    .removeClass("active")
                    .siblings("li")
                    .removeClass("active")
                    .show();
                  //滚动条还原
                  if (_this.sensorListScroll) {
                    _this.sensorListScroll.refresh();
                    _this.sensorListScroll.scrollTo(0, tempScrollInfo);
                    setTimeout(() => {
                      _this.sensorListScroll.refresh();
                    }, 300);
                  }
                } else {
                  //记录滚动条位置
                  if (_this.sensorListScroll) {
                    tempScrollInfo = _this.sensorListScroll.y;
                  }
                  liitem
                    .addClass("active")
                    .siblings("li")
                    .removeClass("active")
                    .hide();
                  _this._initHistoryTemplateController({
                    mountPoint: liitem.find(".historycon"),
                    itemHistoryId: liitem.data("id"),
                  });
                  setTimeout(() => {
                    //隐藏其他，展开显示
                    _this.sensorListScroll && _this.sensorListScroll.refresh();
                  }, 300);
                }
              }
            );
          } else if ($(listDoms).length === 1) {
            //一个的时候 自动显示历史数据
            $(".sensormonitor .sensorlist>ul>li")
              .addClass("active")
              .siblings("li")
              .removeClass("active")
              .hide();
            _this._initHistoryTemplateController({
              mountPoint: $(".sensormonitor .sensorlist>ul>li").find(
                ".historycon"
              ),
              itemHistoryId: $(".sensormonitor .sensorlist>ul>li").data("id"),
            });
            $(
              ".sensormonitor .sensorlist>ul>li span.splitline,.sensormonitor .sensorlist>ul>li .senhistory_btn"
            ).remove();
            $(".sensormonitor .sensorlist>ul>li .sensoritem").css(
              "width",
              "499px"
            );
            //隐藏其他，展开显示
            _this.sensorListScroll && _this.sensorListScroll.destroy();
          }

          //* 环境监测和远程控制tab切换显示
          if ($(".equiplayer p.title span.layertname").length < 1)
            $(this).addClass("blue");
          $(".equiplayer p.title span.layertname").on("click", function () {
            if ($(".equiplayer p.title span.layertname").length > 1) {
              $(this)
                .addClass("active")
                .siblings("span.layertname")
                .removeClass("active");
            } else {
              $(this).addClass("blue");
            }

            $(".sensormonitor .equiplayercon .monitorlist")
              .eq($(this).index())
              .show()
              .siblings(".monitorlist")
              .hide();
            _this.sensorListScroll && _this.sensorListScroll.refresh();
            _this.controllerListScroll && _this.controllerListScroll.refresh();
            _this.thirdDeviceBugListScroll &&
              _this.thirdDeviceBugListScroll.refresh();
          });
          _this.sensorListScroll && _this.sensorListScroll.refresh();
          _this.controllerListScroll && _this.controllerListScroll.refresh();
          _this.thirdDeviceBugListScroll &&
            _this.thirdDeviceBugListScroll.refresh();
          $(".equiplayer p.title span.layertname").first().trigger("click");
        },
        end: () => {
          _this._removeThirdMarkerActiveClass(
            _this.thirdCurrentMarkerTarget._icon
          );
          _this.thirdCurrentMarkerTarget = null;
          _this.thirdCurrentMarkerData = {
            id: null,
            displayName: "",
          };
          _this.thirdSensorList = null;
          _this.hasBug = false;
          _this.xData = [];

          _this.sensorListScroll = null;
          _this.controllerListScroll = null;
          _this.thirdDeviceBugListScroll = null;
        },
      });
    },
    async getInsectStatistics(startTime, endTime) {
      const {
        farmId,
        thirdCurrentMarkerData: { id },
      } = this;
      return new Promise((resolve) => {
        $axios
          .post(snkd.produce.iotAccessThird.getInsectStatistics, {
            farmId: farmId,
            deviceId: id,
            startTime,
            endTime,
          })
          .then((res) => {
            if (res.respCode == 0) {
              this.insectStatisticsEchartsList = res.obj;
              if (res.obj.length > 0) {
                const isShowSymbol = res.obj.length === 1;
                let xData = [],
                  yData = [
                    {
                      name: "温度",
                      type: "line",
                      unit: "℃",
                      yAxisIndex: 1,
                      symbol: "circle",
                      showSymbol: isShowSymbol,
                      areaStyle: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: "rgba(255,204,72,0.2)", // 0% 处的颜色
                            },
                            {
                              offset: 1,
                              color: "rgba(255,204,72, 0)", // 100% 处的颜色
                            },
                          ],
                          global: false,
                        },
                      },
                      data: [],
                    },
                    {
                      name: "湿度",
                      type: "line",
                      unit: "%",
                      yAxisIndex: 1,
                      symbol: "circle",
                      showSymbol: isShowSymbol,
                      areaStyle: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: "rgba(22,93,255,0.2)", // 0% 处的颜色
                            },
                            {
                              offset: 1,
                              color: "rgba(22,93,255, 0)", // 100% 处的颜色
                            },
                          ],
                          global: false,
                        },
                      },
                      data: [],
                    },
                    {
                      name: "虫数",
                      type: "line",
                      unit: "只",
                      yAxisIndex: 0,
                      symbol: "circle",
                      showSymbol: isShowSymbol,
                      areaStyle: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            {
                              offset: 0,
                              color: "rgba(15,198,194,0.2)", // 0% 处的颜色
                            },
                            {
                              offset: 1,
                              color: "rgba(15,198,194, 0)", // 100% 处的颜色
                            },
                          ],
                          global: false,
                        },
                      },
                      data: [],
                    },
                  ];
                res.obj.forEach((item) => {
                  xData.push(item.collectTime);
                  if (item.temperature || String(item.temperature) === 0) {
                    yData[0].data.push(item.temperature);
                  }
                  if (item.humidity || String(item.humidity) === 0) {
                    yData[1].data.push(item.humidity);
                  }
                  yData[2].data.push(item.activation);
                });
                resolve({ xData, yData });
                return;
              }
              resolve(true);
            }
          });
      });
    },
    //* 弹窗模板controller控制
    // 网关弹窗详情中的每条历史数据模板控制
    async _initHistoryTemplateController({ mountPoint, itemHistoryId } = {}) {
      const currentItemHistoryData = this.thirdSensorList.find(
        (item) => item.identifier === itemHistoryId.toString()
      );
      this._initHistoryLoader({ mountPoint });
      const {
        sensor: { unit },
        histories,
      } = await this.getIotAccessThirdDeviceHistoryService({
        itemHistoryId: this.thirdCurrentMarkerData.id * 1,
        identifier: currentItemHistoryData.identifier,
      });
      let xdata = [];
      let ydata = [];
      histories.forEach(({ timestamp, value }) => {
        xdata.push(new Date(timestamp).format("MM.dd hh:mm"));
        ydata.push(value);
      });
      this.thirdEchartfn(xdata, ydata, mountPoint.get(0), unit || "无");
    },
    // 网关弹窗详情的标题和模板内容控制
    _getContentTemplateController({
      thirdSensorList,
      controllerList,
      thirdDeviceBugList,
      bugEchartsList,
      insectStatisticsEchartsList,
      hasBug,
      hasSpore,
      hasInsecticidal,
      itemMarkerData,
    } = {}) {
      let listTpl = `<div class="equiplayercon">
										 		<p class="title">`;
      if (
        (thirdSensorList.length &&
          !controllerList.length &&
          !thirdDeviceBugList.length) ||
        (!thirdSensorList.length &&
          controllerList.length &&
          !thirdDeviceBugList.length) ||
        (!thirdSensorList.length &&
          !controllerList.length &&
          thirdDeviceBugList.length) ||
        (!thirdSensorList.length &&
          !controllerList.length &&
          !thirdDeviceBugList.length)
      ) {
        listTpl += `<span class="layertname">${this.thirdCurrentMarkerData.displayName}</span>`;
      } else {
        thirdSensorList.length > 0 &&
          (listTpl += `<span class="layertname">环境监测</span>`);

        controllerList.length > 0 &&
          (listTpl += `<span class="layertname">远程控制</span>`);

        if (thirdDeviceBugList.length) {
          listTpl += `<span class="layertname">${hasBug ? "虫情设备" : ""}${
            hasSpore ? "孢子设备" : ""
          }${hasInsecticidal ? "杀虫灯设备" : ""}</span>`;
        }
      }

      listTpl += `</p><div class="monitorlistcon">`;
      thirdSensorList.length > 0 &&
        (listTpl += this.getSensorProTemplate({ thirdSensorList }));
      controllerList.length > 0 &&
        (listTpl += this.getControlProTemplate({ controllerList }));
      hasBug &&
        (listTpl += this.getThirdDeviceBugListTemplate({
          thirdDeviceBugList,
          hasBug,
          bugEchartsList,
        }));
      hasSpore &&
        (listTpl += this.getThirdDeviceBugListTemplate({
          thirdDeviceBugList,
          hasBug: false,
          bugEchartsList,
        }));
      hasInsecticidal &&
        (listTpl += this.getThirdDeviceSCDTemplate(
          insectStatisticsEchartsList
        ));
      itemMarkerData.vendorCode === 3 &&
        (listTpl += this.getVendorCode3Tpl(itemMarkerData.onlineFlag));

      if (
        !thirdSensorList.length &&
        !controllerList.length &&
        !hasBug &&
        !hasSpore &&
        !hasInsecticidal &&
        itemMarkerData.vendorCode !== 3
      ) {
        listTpl +=
          '<div class="monitorlist nodata"><ul class="clearfix"><div class="nodata">暂无数据</div></ul></div>';
      }
      listTpl += `</div></div>`;
      return listTpl;
    },
    getThirdDeviceSCDTemplate(list) {
      let tplStr;
      if (list && list.length) {
        tplStr = `<div class="monitorlist shaC-wrap">
											           <div class="shaC-echart"></div>
                               </div>
                             `;
      } else {
        tplStr +=
          '<div class="monitorlist nodata"><ul class="clearfix"><div class="nodata" style="width: 100%">暂无数据</div></ul></div>';
      }
      return tplStr;
    },
    getVendorCode3Tpl(onlineFlag) {
      let tplStr = `
      <div class="daLu-wrap">
        <div class="daLuInfo">
          <div class="daLuImg"><img src="${require("@/assets/images/iot/daLu/device.png")}" alt=""></div>
          <div class="states ${onlineFlag ? "online" : "offline"}">
            <div class="statesImg"><img src="${require(`@/assets/images/iot/daLu/${
              onlineFlag ? "online" : "offline"
            }.png`)}" alt=""></div>
            <div class="datateAlt">设备${onlineFlag ? "在线" : "离线"}</div>
          </div>
        </div>

        <div class="daLuBtn">
           <div class="btnImg"><img src="${require("@/assets/images/iot/daLu/setting.png")}" alt=""></div>
           <div class="btnTxt">控制设备</div>
        </div>
      </div>
    `;
      return tplStr;
    },
    //* 弹窗模板
    //* 虫情孢子设备
    getThirdDeviceBugListTemplate({
      thirdDeviceBugList,
      hasBug,
      bugEchartsList,
    } = {}) {
      let tplStr = "";
      tplStr += `
							<div>
							<div class="QggcQDeviceList">
									<div class="QggcQDeviceList-wrap" style="padding: ${
                    (bugEchartsList && bugEchartsList.length) ||
                    (thirdDeviceBugList && thirdDeviceBugList.length)
                      ? "20px"
                      : "0"
                  }">
										<div style="display: ${
                      hasBug && bugEchartsList && bugEchartsList.length
                        ? "block"
                        : "none"
                    }">
											<div class="QggcQ-chart-tit">虫情趋势</div>
											<div class="QggcQDevice-echart" style="text-align:center;line-height: 100px">暂无数据</div>
										</div>
										<div class="line" style="display:${
                      hasBug &&
                      bugEchartsList.length &&
                      thirdDeviceBugList.length
                        ? "block"
                        : "none"
                    }"></div>
										<div class="QggcQ-pic-tit" style="display:${
                      hasBug && thirdDeviceBugList.length ? "block" : "none"
                    }">虫情图片</div>
								 		<div class="QggcQDeviceList-main">`;
      if (thirdDeviceBugList.length > 0) {
        thirdDeviceBugList.map((item) => {
          item.collectTime = dateFormat(
            item.collectTime,
            "yyyy-MM-dd hh:mm:ss"
          );
          tplStr += `
							<div class="QggcQDeviceItem">
								<div class="QggcQDeviceItem-main">
									<div class="imgWrap">
										<img src="${item.bugPic}" alt="" style="display:${
            item.bugPic ? "block" : "none"
          }"/>
										<img src="${this.noImg}" style="width:38px;height:32px;display:${
            item.bugPic ? "none" : "block"
          }" alt=""/>
									</div>
									<div class="bugNum" style="display: ${hasBug ? "block" : "none"};">虫数 : ${
            item.bugNum === null ? "--" : item.bugNum
          }</div>
									<div class="collectTime">${item.collectTime}</div>
								</div>
							</div>
					`;
        });
      }
      if (
        (hasBug && !bugEchartsList.length && !thirdDeviceBugList.length) ||
        (!hasBug && !thirdDeviceBugList.length)
      ) {
        tplStr +=
          '<div class="monitorlist nodata"><ul class="clearfix"><div class="nodata" style="width: 100%">暂无数据</div></ul></div>';
      }
      tplStr += `</div>
								</div>
							 </div>
							 </div>`;
      return tplStr;
    },
    // 生成传感指标模板
    getSensorProTemplate({ thirdSensorList } = {}) {
      let tplStr = "";
      tplStr += `<div class="monitorlist sensorlist"><ul class="clearfix">`;
      thirdSensorList.forEach((item) => {
        tplStr += `<li data-id="${item.identifier}">
					<div class="sensorlicon clearfix">
					<div class="sensoricon">
						<img src="${
              item.icon ||
              "https://zaiot.oss-cn-hangzhou.aliyuncs.com/wechat/img/icon_eq_default.png"
            }" alt="" />
					</div>
					<div class="sensoritem">
					<p>${item.name}</p>`;
        tplStr += `<p>单位：<span>${item.unit || "无"}</span></p>
				<div class="sensor-section">${
          item.displayName
            ? `<div class="rule-name" style="color:${
                item.displayColor || "#FF994E"
              };border-color:${item.displayColor || "#FF994E"}">${
                item.displayName
              }</div>`
            : ""
        }<div class="sensornum za_number ${
          item.value ? "" : "no-value"
        }" num="${item.value || "--"}"></div></div></div>
				<span class="splitline"></span><div class="senhistory_btn"></div></div>
				<div class="sensor_history"><div class="historycon"></div></div></li>`;
      });
      tplStr += `</ul></div>`;
      return tplStr;
    },
    // 生成控制指标模板
    getControlProTemplate({ controllerList } = {}) {
      let tplStr = "";
      tplStr += `<div class="monitorlist controlerlist"><ul class="clearfix">`;
      controllerList.forEach((item) => {
        tplStr += `<li  data-id="${item.num}" class="controler">
            <div class="sensorlicon clearfix">
            <div class="sensoricon"><img src="${
              item.icon ||
              "https://zaiot.oss-cn-hangzhou.aliyuncs.com/wechat/img/icon_eq_default.png"
            }" alt="" /></div> <div class="sensoritem"> <p>${item.name}</p>`;

        tplStr += `<div class="sensor-section"><div class="sensornum za_number ${
          item.value ? "" : "no-value"
        }" num="${
          (item.frontStyle === "button"
            ? item.valueMap[item.value]
            : item.value) || "--"
        }${item.frontStyle === "tab" ? item.unit : ""}">${
          (item.frontStyle === "button"
            ? item.valueMap[item.value]
            : item.value) || "--"
        }${item.frontStyle === "tab" ? item.unit : ""}</div></div>`;
        tplStr += `</div></div> <div class="sensor_history"> <div class="historycon"></div> </div> </li>`;
      });
      tplStr += `</ul></div>`;
      return tplStr;
    },
    //* 虫情走势loader模板
    async _initThirdDeviceBugHistoryLoader({ mountPoint } = {}) {
      mountPoint.html(
        `<div class="thirdDeviceBug">
					<div class="loader-innering spping-fade-loader">
						<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
					</div>
				 </div>
				`
      );
    },
    //* 历史数据的loader模板
    async _initHistoryLoader({ mountPoint } = {}) {
      mountPoint.html(
        `<div class="loader historyload">
					<div class="loader-inner ball-spin-fade-loader">
						<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
					</div>
				 </div>
				`
      );
    },
    //* 传感指标里的value数据filter用图片显示
    _thirdZaNumber: function (ele) {
      var num = ele.attr("num");
      if (!isNaN(num)) {
        num = Number(num) + "";
        if (num.split("").length > 0) {
          var arr = num.split("");
          var numstr = "";
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] == ".") {
              numstr += '<span class="number_pointer"></span>';
            } else if (!isNaN(arr[i])) {
              numstr += '<span class="number_' + arr[i] + '"></span>';
            } else {
              numstr += '<span class="number_other">' + arr[i] + "</span>";
            }
          }
          ele.html(numstr);
          setTimeout(function () {
            ele.find("span").not(".number_pointer").addClass("aninum");
          }, 0);
        }
      } else {
        let htmlstr = num;
        if (num === "停") {
          htmlstr = "<i style='color:#FEBD4D;font-style:normal;'>停</i>";
        } else if (num === "开") {
          htmlstr = "<i style='color:#30E034;font-style:normal;'>开</i>";
        } else if (num === "关") {
          htmlstr = "<i style='color:#FD4F4F;font-style:normal;'>关</i>";
        }
        ele.html(htmlstr);
      }
    },

    // ToDo: ------ utils ------
    //* 获取最近一个月时间范围
    getLastMonth() {
      var end = new Date();
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.endTime = year + "-" + month + "-" + day;
      var endMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.startTime = year - 1 + "-" + 12 + "-" + day;
      } else {
        var startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.startTime =
              year +
              "-" +
              (month - 1) +
              "-" +
              (startMonthDay - (endMonthDay - day));
          } else {
            dateObj.startTime = year + "-" + (month - 1) + "-" + startMonthDay;
          }
        } else {
          dateObj.startTime = year + "-" + (month - 1) + "-" + day;
        }
      }
      console.log(JSON.stringify(dateObj));
      return dateObj;
    },
    //* 获取当月时间1日至当天时间
    getMapLastTime() {
      const nowTime = new Date();
      const endTime = dateFormat(nowTime, "yyyy-MM-dd");
      const nowY = nowTime.getFullYear();
      const nowM = nowTime.getMonth() + 1;
      let startTime = `${nowY}-${nowM > 9 ? nowM : "0" + nowM}-01`;
      const temp = Number(dateFormat(endTime, "dd")) - 1;
      if (temp > 6) {
        const date = temp - 5;
        startTime = `${nowY}-${nowM > 9 ? nowM : "0" + nowM}-${
          date > 9 ? date : "0" + date
        }`;
      }
      return { startTime, endTime };
    },
    // 设置选中的marker点的active
    _setThirdMarkerActiveClass(dom) {
      dom.classList.add("active");
    },
    // 去除marker点的active
    _removeThirdMarkerActiveClass(dom) {
      dom.classList.remove("active");
    },
    // 移动map
    async _thirdMapMovePos(coordinate) {
      const { map } = this;
      await this.setThirdAsyncFun();
      const mapLatLng = map.getBounds(); // 地图右上角 左下角 经纬度
      const latMarginValue =
        mapLatLng["_northEast"].lat - mapLatLng["_southWest"].lat;
      const bottomH = latMarginValue / 5; // 产品要求，点击之后marker点需要偏地图下方一点，所以寻找了一个差值
      const { lat, lng } = coordinate;
      // panTo可以将map的中心点设为新的坐标值
      map.panTo({
        lat: lat + bottomH,
        lng,
      });
    },
    // 延迟
    setThirdAsyncFun(time = 600) {
      return new Promise((resolve) => {
        const timer = setTimeout(() => {
          resolve();
          clearTimeout(timer);
        }, time);
      });
    },
    // marker点的html模版
    _returnThirdHtmlTemplate({ icon, vendorCode }) {
      return `
        <div class="icon-inner vendorCode-${vendorCode}">
          <header class="header" style="background-color: #ff8a65;">
          	<img src="${icon}" class="icon-image"/>
          </header>
          <footer class="footer"></footer>
        </div>
      `;
    },
    // echarts
    async thirdEchartfn(xData, yData, domobj, unit) {
      if (!domobj) {
        return false;
      }
      if (!xData.length && !yData.length) {
        domobj.innerHTML =
          '<div style="padding-top: 100px; text-align: center; font-size: 18px; color: #2CD2A9;">近期暂无数据<div>';
        return;
      }
      var myChart = echarts && echarts.init(domobj);
      var option = {
        title: { show: false, text: "", subtext: "" },
        tooltip: {
          show: true,
          trigger: "axis",
          borderColor: "#64C3A4",
          backgroundColor: "rgba(100,195,164,1)",
          padding: [5, 10, 2],
          textStyle: { color: "#fff" },
          formatter: function (a) {
            return `<p class='echartBox' style='text-align:left;line-height:24px;padding:3px;'>${
              a[0].name
            }<br/>数值：${
              a[0].value === undefined ? "--" : a[0].value
            }${unit.replace(/无/, "")}</p>`;
          },
          axisPointer: {
            lineStyle: { color: "#64C3A4", width: 1 },
            crossStyle: { color: "#00E5FF", width: 3 },
          },
        },
        legend: {
          data: [],
        },
        toolbox: {
          show: false,
        },
        calculable: false,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xData,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#73867A",
              },
              formatter: function (a) {
                return a.split(" ")[0] + "\n" + a.split(" ")[1];
              },
            },
            axisLine: {
              lineStyle: { color: "rgba(255,255,255,0.1)", width: 1 },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: { color: "rgba(48,138,110,0.2)" },
            },
            axisLabel: { show: true, textStyle: { color: "#73867A" } },
            axisLine: {
              lineStyle: { color: "rgba(255,255,255,0.1)", width: 1 },
            },
          },
        ],
        grid: {
          left: 48,
          right: 30,
          top: 20,
          bottom: 43,
          borderWidth: 0,
        },
        series: [
          {
            name: "传感器历史数据",
            type: "line",
            smooth: true,
            clickable: false,
            itemStyle: {
              normal: {
                color: "#73867A",
                lineStyle: {
                  color: "#308A6E",
                },
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(109,250,115,0.4)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(100,195,164,0)", // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
              emphasis: {
                lineStyle: {
                  color: "#fff",
                },
              },
            },
            data: yData,
            symbol: "circle",
            symbolSize: 1,
            showAllSymbol: true,
          },
        ],
      };
      var maxstrlen = Math.max.apply(null, yData);
      if (maxstrlen.toString().length > 4) {
        var ww = (maxstrlen.toString().length - 4) * 7 + 50;
        option.grid.x = ww;
      }
      myChart.setOption(option);
    },
    async QggcQDeviceEchartfn(xData, yData, domobj) {
      if (!domobj) {
        return false;
      }
      if (yData.length === 0) {
        domobj.innerHTML =
          '<div style="padding-top: 60px; text-align: center; font-size: 18px; color: #2CD2A9;">近期暂无数据<div>';
        return;
      }
      var myChart = echarts && echarts.init(domobj);
      var option = {
        title: { show: false, text: "", subtext: "" },
        tooltip: {
          show: true,
          trigger: "axis",
          borderColor: "#64C3A4",
          backgroundColor: "rgba(100,195,164,1)",
          padding: [5, 10, 2],
          textStyle: { color: "#fff" },
          formatter: function (a) {
            return `<p class='echartBox' style='text-align:left;line-height:24px;padding:3px;'>${
              a[0].name
            }<br/>数值：${a[0].value === undefined ? "--" : a[0].value}</p>`;
          },
          axisPointer: {
            type: "line",
            lineStyle: { color: "#64C3A4", width: 1 },
          },
        },
        legend: {
          data: [],
        },
        toolbox: {
          show: false,
        },
        calculable: false,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            splitNumber: xData.length / 10,
            data: xData,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              fontSize: 14,
              textStyle: {
                color: "rgba(22,142,122,1)",
              },
            },
            axisLine: {
              lineStyle: { color: "rgba(22,142,122,0.6)", width: 1 },
            },
            axisTick: { inside: true },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "虫数",
            nameTextStyle: {
              fontSize: 14,
              color: "rgba(22,142,122,1)",
            },
            splitLine: {
              show: true,
              lineStyle: { color: "rgba(22,142,122,0.2)" },
            },
            axisLabel: {
              show: true,
              fontSize: 14,
              color: "rgba(22,142,122,1)",
              margin: 7,
            },
            axisLine: {
              lineStyle: { color: "rgba(22,142,122,0.6)", width: 1 },
            },
            axisTick: { inside: true },
            // minInterval: 1,
            splitNumber: 3,
          },
        ],
        grid: {
          left: 44,
          right: "1%",
          bottom: 40,
          top: 30,
        },
        series: [
          {
            name: "第三方虫情分析历史数据",
            type: "line",
            smooth: true,
            clickable: false,
            lineStyle: {
              color: "rgb(63,106,98)",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 246, 255, 0.2)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(52, 198, 162, 0)", // 100% 处的颜色
                  },
                ],
                global: false,
              },
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 246, 255, 0.2)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(52, 198, 162, 0)", // 100% 处的颜色
                  },
                ],
                global: false,
              },
            },
            data: yData,
            symbol: "circle",
            symbolSize: 1,
            showAllSymbol: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    async shacDeviceEchartsfn(xData, yData, domobj, interval = 4) {
      if (!domobj) return false;
      if (yData.length === 0) {
        domobj.innerHTML =
          '<div style="padding-top: 60px; text-align: center; font-size: 18px; color: #2CD2A9;">近期暂无数据<div>';
        return;
      }
      let maxValue1 = this.processNum(this.calMax(yData[2].data), interval);
      let maxValue2 = this.processNum(
        this.calMax([...yData[0].data, ...yData[1].data]),
        interval
      );
      var myChart = echarts && echarts.init(domobj);
      const option = {
        color: ["#FFCC48", "#165DFF", "#0FC6C2"],
        title: { show: false, text: "", subtext: "" },
        tooltip: {
          show: true,
          trigger: "axis",
          borderColor: "#09eef6",
          backgroundColor: "rgba(9,238,246,0.6)",
          padding: [5, 10, 2],
          textStyle: { color: "#fff" },
          axisPointer: {
            type: "line",
            lineStyle: { color: "rgba(9,238,246,0.6)", width: 1 },
          },
          formatter: function (a) {
            const timestamp = a[0].name ? Number(a[0].name) : "";
            let str =
              "<p class='echartBox' style='text-align:left;line-height:24px;padding:3px;'>";
            if (
              new Date(timestamp).format("yyyy") === new Date().getFullYear()
            ) {
              str += new Date(timestamp).format("yyyy.MM.dd hh:mm:ss");
            } else {
              str += new Date(timestamp).format("yyyy.MM.dd hh:mm:ss");
            }
            if (a.length > 0) {
              a.forEach((item) => {
                str += `<br/>${item.seriesName}: ${item.value}`;
              });
            }
            str += "</p>";
            return str;
          },
        },
        legend: {
          type: "plain",
          icon: "circle",
          data: ["温度", "湿度", "虫数"],
          textStyle: {
            color: "#168E7A",
          },
        },
        toolbox: {
          show: false,
        },
        calculable: false,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xData, // xData
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              fontSize: 16,
              color: "rgba(89,122,138,1)",
              interval: "auto",
              formatter: function (a) {
                let timestamp = a ? Number(a) : "";
                if (
                  new Date(timestamp).format("yyyy") ===
                  new Date().getFullYear()
                ) {
                  return (
                    new Date(timestamp).format("MM.dd") +
                    "\n" +
                    new Date(timestamp).format("hh:mm")
                  );
                } else {
                  return (
                    new Date(timestamp).format("MM.dd") +
                    "\n" +
                    new Date(timestamp).format("hh:mm")
                  );
                }
              },
            },
            axisLine: {
              lineStyle: { color: "rgba(89,122,138,0.6)", width: 1 },
            },
            axisTick: { inside: true },
            offset: 20,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "虫数",
            min: 0,
            max: maxValue1,
            interval: maxValue1 / interval,
            splitNumber: 4,
            nameTextStyle: {
              fontSize: 16,
              color: "rgba(89,122,138,1)",
            },
            splitLine: {
              show: true,
              lineStyle: { color: "rgba(89,122,138,0.2)" },
            },
            axisLabel: {
              show: true,
              fontSize: 16,
              color: "rgba(89,122,138,1)",
              margin: 14,
              formatter: function (a) {
                let num = 0;
                let symbol = "";
                if (a < 0) {
                  num = 0 - a;
                  symbol = "-";
                } else {
                  num = a;
                  symbol = "";
                }
                let units = ["", "万", "亿"];
                let steps = [10000, 1000, 10];
                let pos = 0;
                while (num / steps[pos] >= 1) {
                  num = num / 10000;
                  pos++;
                }
                return symbol + num + units[pos];
              },
            },
            axisLine: {
              lineStyle: { color: "rgba(89,122,138,0.6)", width: 1 },
            },
            axisTick: { inside: true },
            data: yData[2].data,
          },
          {
            type: "value",
            name: "温度℃  湿度%",
            min: 0,
            max: maxValue2,
            interval: maxValue2 / interval,
            splitNumber: 4,
            position: "right",
            nameTextStyle: {
              fontSize: 16,
              padding: [0, 70, 0, 0],
              color: "rgba(89,122,138,1)",
            },
            splitLine: {
              show: true,
              lineStyle: { color: "rgba(89,122,138,0.2)" },
            },
            axisLabel: {
              show: true,
              fontSize: 16,
              color: "rgba(89,122,138,1)",
              margin: 14,
            },
            axisLine: {
              lineStyle: { color: "rgba(89,122,138,0.6)", width: 1 },
            },
            axisTick: { inside: true },
            data: [...yData[0].data, ...yData[1].data],
          },
        ],
        grid: {
          top: "19%",
          bottom: "24%",
          left: "12%",
          right: "12%",
        },
        series: [],
      };
      if (yData[0].data.length && !yData[1].data.length) {
        option.legend.data = ["温度", "虫数"];
        option.yAxis[1].name = "温度℃";
      }
      if (!yData[0].data.length && yData[1].data.length) {
        option.legend.data = ["湿度", "虫数"];
        option.yAxis[1].name = "湿度%";
      }
      yData[0].data.length && option.series.push(yData[0]);
      yData[1].data.length && option.series.push(yData[1]);
      option.series.push(yData[2]);
      myChart.setOption(option);
    },
    processNum(num, interval) {
      if (num.toString().charAt(0) === "9") {
        num = parseInt("1" + "0".repeat(num.toString().length));
        if (num % interval === 0) {
          return num;
        }
        num += 1;
        if (num % interval === 0) {
          return num;
        }
      }

      const firstDigit = parseInt(num.toString().charAt(0));
      num = (firstDigit + 1) * Math.pow(10, num.toString().length - 1);

      if (num % interval === 0) {
        return num;
      }

      num = (firstDigit + 2) * Math.pow(10, num.toString().length - 1);

      if (num % interval === 0) {
        return num;
      }

      return num;
    },
    calMax(arr) {
      let max = Math.max.apply(null, arr); // 获取最大值方法
      let maxint = Math.ceil(max / 5); // 向上以5的倍数取整
      // 最终设置的最大值
      return maxint * 5 + 5; // 输出最大值
    },
  },
};
